export default __webpack_public_path__ + "static/media/Kaggen_neutral.e0105fcb.jpg";